/* eslint no-console: 0 */
/* global axios */
/* eslint no-undef: "error" */
/* eslint no-unused-expressions: ["error", { "allowShortCircuit": true }] */
import endPoints from './endPoints';

export default {
  fetchFacebookPages(token, accountId) {
    const urlData = endPoints('fetchFacebookPages');
    urlData.params.omniauth_token = token;
    return axios.post(urlData.url(accountId), urlData.params);
  },

  fetchFacebookCommentsPages(token, accountId) {
    const urlData = endPoints('fetchFacebookCommentsPages');
    urlData.params.omniauth_token = token;
    return axios.post(urlData.url(accountId), urlData.params);
  },

  createFacebookCommentsChannel(params, accountId) {
    const url = `api/v1/accounts/${accountId}/facebook_comments/authorization`;
    return axios.post(url, params);
  },
};
